import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import { IApplication } from "../../models/application/i-application";
import { ProfileCardComponent } from '@zaeper/angular-dashboard-view-lib';
import { ZTemplateDirective } from '@zaeper/angular-core-lib';
import { NgTemplateOutlet } from "@angular/common";

@Component( {
  selector: "app-application-overview-item",
  templateUrl: './application-overview-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProfileCardComponent, ZTemplateDirective, NgTemplateOutlet
  ]
} )
export class ApplicationOverviewItemComponent {
  @Input( "application" ) application!: IApplication;
  @Input( "useDynamicWidth" ) useDynamicWidth: boolean = false;
  @Input( "styleClass" ) styleClass: string = "";

  @Output( "onClick" ) onClick: EventEmitter<void> = new EventEmitter<void>();
  @ContentChild( 'actions', { read: TemplateRef } ) actionsTemplate!: TemplateRef<any>;
}
